// extracted by mini-css-extract-plugin
export default {"size":"Tooltip_size__OTl-H","link":"Tooltip_link__gDznX","tooltip":"Tooltip_tooltip__sqcUG"};